import React from 'react';
import { Icon } from './Icon.jsx';

export function Badge({
  tone = 'neutral', size = 'md', icon, count, children, className = '', ...rest
}) {
  const cls = ['sp-badge', 'sp-badge--' + tone, size === 'sm' && 'sp-badge--sm', className]
    .filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {icon && <Icon name={icon} size={size === 'sm' ? 11 : 12} />}
      {children}
      {count != null && <span className="sp-badge__count">{count}</span>}
    </span>
  );
}
